/* eslint-disable */
import React from "react";
import { Box, Button, MenuItem, Select } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

const TOKEN_KEY = "beg_model_token";
const getToken = (): string => { try { return window.localStorage.getItem(TOKEN_KEY) || ""; } catch (e) { return ""; } };

const linkSx = { color: "common.white", fontWeight: 600, fontSize: 13, textTransform: "none" as const };

export const UserBar: React.FC = () => {
  const logged = !!getToken();

  const logout = () => { try { window.localStorage.removeItem(TOKEN_KEY); } catch (e) {} window.location.href = "/"; };

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, ml: "auto" }}>
      <Button component={RouterLink} to="/contact" sx={linkSx}>Contact</Button>
      {logged ? (
        <>
          <Button component={RouterLink} to="/account" sx={linkSx}>My account</Button>
          <Button onClick={logout} sx={{ ...linkSx, display: { xs: "none", md: "inline-flex" } }}>Logout</Button>
        </>
      ) : (
        <Button component={RouterLink} to="/login" variant="contained" size="small"
          sx={{ backgroundColor: "#d4163c", fontWeight: 700, borderRadius: "10px", px: 2.5, "&:hover": { backgroundColor: "#a8102f" } }}>
          LOGIN
        </Button>
      )}
      <Select value="EN" size="small" variant="outlined"
        sx={{ display: { xs: "none", md: "inline-flex" }, color: "#fff", height: 30, fontSize: 12, borderRadius: "10px", ".MuiOutlinedInput-notchedOutline": { borderColor: "rgba(255,255,255,.2)" }, ".MuiSvgIcon-root": { color: "#fff" } }}>
        <MenuItem value="EN">EN</MenuItem>
      </Select>
    </Box>
  );
};
